export default __webpack_public_path__ + "static/media/icon_awesome-code.74ddd571.svg";